import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isDiagnostico = location.pathname === '/diagnostico';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return <>
      <header className={`fixed top-0 w-full z-[100] transition-all duration-300 ${isScrolled ? 'bg-[#F7F4ED]/90 backdrop-blur-[12px] border-b border-carbon/10' : 'bg-transparent'}`} data-id="element-99">
        <div className="max-w-[1200px] mx-auto px-6 md:px-20 h-[64px] md:h-[72px] flex items-center justify-between" data-id="element-100">
          <Link to="/" className="flex items-center" data-id="element-101">
            <span className="font-display font-bold text-[15px]" style={{
            letterSpacing: '0.05em',
            color: '#214D43'
          }} data-id="element-102">
              ORIGEN
            </span>
            <span className="font-display text-[15px] ml-1" style={{
            letterSpacing: '0.05em',
            fontWeight: 600,
            color: '#6E8F80'
          }} data-id="element-103">
              STUDIO
            </span>
          </Link>

          {!isDiagnostico ? <>
              {/* Desktop Nav */}
              <nav className="hidden md:flex items-center gap-10" data-id="element-104">
                <a href="#metodologia" className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-105">
                  Metodología
                </a>
                <a href="#sectores" className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-106">
                  Sectores
                </a>
                <Link to="/diagnostico" className="font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-107">
                  Diagnóstico
                </Link>
              </nav>

              {/* Desktop CTA */}
              <div className="hidden md:block" data-id="element-108">
                <Link to="/diagnostico" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[13px] px-5 py-2.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-109">
                  Diagnosticar mi sitio web
                </Link>
              </div>

              {/* Mobile Menu Toggle */}
              <button className="md:hidden text-carbon" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-110">
                {isMobileMenuOpen ? <X size={24} data-id="element-111" /> : <Menu size={24} data-id="element-112" />}
              </button>
            </> : <div className="flex items-center gap-4 md:gap-8" data-id="element-113">
              <Link to="/" className="hidden md:block font-body text-[14px] text-carbon/60 hover:text-carbon/100 transition-opacity duration-150" data-id="element-114">
                ← Volver al inicio
              </Link>
            </div>}
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {!isDiagnostico && isMobileMenuOpen && <div className="fixed inset-0 z-[90] bg-arena pt-[72px] px-6 pb-10 flex flex-col md:hidden" data-id="element-115">
          <nav className="flex flex-col gap-8 mt-8" data-id="element-116">
            <a href="#metodologia" className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-117">
              Metodología
            </a>
            <a href="#sectores" className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-118">
              Sectores
            </a>
            <Link to="/diagnostico" className="font-body text-xl text-carbon/80" onClick={() => setIsMobileMenuOpen(false)} data-id="element-119">
              Diagnóstico
            </Link>
          </nav>
          <div className="mt-auto" data-id="element-120">
            <Link to="/diagnostico" className="flex items-center justify-center w-full bg-verde text-arena font-display font-semibold text-[15px] px-7 py-4 rounded-[6px] hover:bg-verde-hover transition-colors duration-200" onClick={() => setIsMobileMenuOpen(false)} data-id="element-121">
              Diagnosticar mi sitio web
            </Link>
          </div>
        </div>}
    </>;
}